import { useState, useRef } from 'react';

export default function NewsletterSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('company_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      form.reset();
      return;
    }

    formData.delete('company_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9rgpk7nahb7382ovma0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        if (msg.includes('spam') || msg.includes('form data is spam')) {
          setErrorMsg('订阅失败，请稍后再试');
        } else {
          setErrorMsg(msg);
        }
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="bg-primary-600">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/50 mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl text-background-50"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            加入老色哥社区
          </h2>
          <p className="text-sm md:text-base text-primary-100 mb-8 leading-relaxed">
            订阅老色哥邮件通讯，第一时间获取最新穿搭指南、活动资讯和专属福利
          </p>

          {status === 'success' ? (
            <div className="bg-primary-500/40 rounded-lg p-6 text-background-50">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/20 mx-auto mb-3">
                <i className="ri-check-line text-xl text-background-50"></i>
              </div>
              <p className="text-lg font-semibold">订阅成功！</p>
              <p className="text-sm text-primary-100 mt-1">感谢加入老色哥社区，最新内容即将送达您的邮箱。</p>
            </div>
          ) : (
            <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="">
              <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <input
                  type="email"
                  name="email"
                  placeholder="请输入您的邮箱地址"
                  required
                  className="flex-1 px-4 py-3 text-sm bg-background-50 text-foreground-900 rounded-md border-0 focus:outline-none focus:ring-2 focus:ring-primary-300 placeholder:text-foreground-400"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium text-sm rounded-md transition-colors duration-200 whitespace-nowrap"
                >
                  免费订阅
                </button>
              </div>
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              {status === 'error' && (
                <p className="text-xs text-red-200 mt-3">{errorMsg}</p>
              )}
            </form>
          )}

          <p className="text-xs text-primary-200 mt-4">
            我们尊重您的隐私，绝不发送垃圾邮件。可随时退订。
          </p>
        </div>
      </div>
    </section>
  );
}